import { makeAutoObservable, runInAction } from 'mobx';

import ApiService from 'src/services/ApiService';
import { Profile } from 'src/models/Profile';
import { handleStateError } from 'src/errors';
import { STORE_NAME } from 'src/utils/constants';
import { RootStore } from './RootStore';

export default class ProfileStore {
  private storeName = STORE_NAME.PROFILE_STORE;
  private rootStore: RootStore;
  private apiService: ApiService;
  profile?: Profile;

  constructor(rootStore: RootStore, apiService?: ApiService) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    this.apiService = apiService || new ApiService(this.rootStore.authStore.getWhsAccessToken);
  }

  loadProfile = async (): Promise<Profile | undefined> => {
    try {
      const profile = await this.apiService.getProfile();
      if (profile) {
        runInAction(() => {
          this.profile = profile;
        });
      }

      return profile;
    }
    catch (error) {
      handleStateError(error, this.storeName);
    }
  };
}
